<lib-snackbar-layout qaTag="$$Snackbar_Container_Message">
    <ng-container message>
        {{ data.Data }}
    </ng-container>
    <ng-container actions>
        @if (data.ActionButtonText) {
            <lib-button
                [kind]="ButtonKind.Link"
                qaTag="snackbar-action-button"
                (clicked)="OnAction()">
                <ng-container label>{{ data.ActionButtonText }}</ng-container>
            </lib-button>
        }
    </ng-container>

    <ng-container close>
        @if (data.IsClosable) {
            <lib-icon-button
                [icon]="Icon.Common.Close"
                [kind]="ButtonKind.NeutralTertiary"
                [size]="ButtonSize.Medium"
                qaTag="snackbar-close-icon"
                (clicked)="Dismiss()"></lib-icon-button>
        }
    </ng-container>
</lib-snackbar-layout>
